export const isConfigEnabled = ({ value }) => value === "t" || value === true
